export enum ESearchType {
  ADDRESS = 'address',
  PLOT_NUMBER = 'plotNumber',
}
